import { gql } from "config/graphql";

export const BUSINESS_FIELDS = gql`
  fragment BusinessFields on Business {
    id
    name
    slug
  }
`;
